// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CommsThread from './data'

export default function CommsThreadFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CommsThread">
      <CommsThread {...props}>
        {children}
      </CommsThread>
    </Flow>
  )
}
